import React from 'react';
import { Container } from 'react-bootstrap';

function Year4 () {
    return (
        <div>
            <Container>
            <table class="table table-hover">
  <thead>
    <tr>
      <th scope="col">#</th>
      <th colspan="2">Name</th>
      <th scope="col">Download</th>
    </tr>
  </thead>
  <tbody>
  <tr>
      <th scope="row">***</th>
      <td colspan="2">7th Sem</td>
      <td><a style={{textDecoration:'none'}} href='https://drive.google.com/drive/folders/1cTWrQoJRrTOUGpdjEknSI5gQjEGZZpmW' download> Open <i class="fa fa-download" style={{fontSize:'17px'}}></i></a></td>
    </tr>
    <tr>
      <th scope="row">***</th>
      <td colspan="2">8th Sem</td>
      <td><a style={{textDecoration:'none'}} href='https://drive.google.com/drive/folders/1gIm839kYVBvDgzqtfmFWEhlTtRMzlP1l' download> Open <i class="fa fa-download" style={{fontSize:'17px'}}></i></a></td>
    </tr>
    <tr>
      <th scope="row">1</th>
      <td colspan="2">IOT</td>
      <td><a style={{textDecoration:'none'}} href='https://docs.google.com/document/d/1FFvAGNjUiyeyoMJLhPEQ-_41ozA7fgyL/edit' download> Open <i class="fa fa-download" style={{fontSize:'17px'}}></i></a></td>
    </tr>
    <tr>
        <th scope='row'>2</th>
        <td colspan="2">IOT Unit 3</td>
        <td><a style={{textDecoration:'none'}} href='https://docs.google.com/document/d/1oKTP-TlO-9HTmyEQi0cQlB2F5p2Zp_MF/edit?usp=drive_link&ouid=100677563929140927255&rtpof=true&sd=true' download> Open <i class="fa fa-download" style={{fontSize:'17px'}}></i></a></td>
    </tr>
    <tr>
      <th scope="row">3</th>
      <td colspan="2">EE&DM (unit 1,2)</td>
      <td><a style={{textDecoration:'none'}} href='https://docs.google.com/document/d/14LDskLUPDJ8j5LM9spueC2lkS0Y0Jurq/edit?usp=drive_link&ouid=100677563929140927255&rtpof=true&sd=true' download> Open <i class="fa fa-download" style={{fontSize:'17px'}}></i></a></td>
    </tr>
    <tr>
      <th scope="row">5</th>
      <td colspan="2">EE&DM (Unit 3,4) </td>
      <td><a style={{textDecoration:'none'}} href='https://docs.google.com/document/d/1GfdWwC_m6pUJv2h1Rn2z9TXZ7N2zW5x6/edit?usp=drive_link&ouid=100677563929140927255&rtpof=true&sd=true' download> Open <i class="fa fa-download" style={{fontSize:'17px'}}></i></a></td>
    </tr>
    <tr>
      <th scope="row">6</th>
      <td colspan="2">DM Notes</td>
      <td><a style={{textDecoration:'none'}} href='https://drive.google.com/file/d/1dH-W75lKfYvlZTbzcz6KyQzkEZdVhUFq/view?usp=sharing' download> Open <i class="fa fa-download" style={{fontSize:'17px'}}></i></a></td>
    </tr>
    <tr>
      <th scope="row">7</th>
      <td colspan="2">DM</td>
      <td><a style={{textDecoration:'none'}} href='https://drive.google.com/file/d/1iXPa-oSVSpfI2Oio89Lh4m4qr_vJAJmb/view?usp=drive_link' download> Open <i class="fa fa-download" style={{fontSize:'17px'}}></i></a></td>
    </tr>
    <tr>
      <th scope="row">8</th>
      <td colspan="2">DM (Unit 1,2) </td>
      <td><a style={{textDecoration:'none'}} href='https://drive.google.com/file/d/1S1N5w08ipX2vZvuLUcWY2O5gk2CblnfF/view?usp=drive_link' download> Open <i class="fa fa-download" style={{fontSize:'17px'}}></i></a></td>
    </tr>
    <tr>
      <th scope="row">9</th>
      <td colspan="2">DM (Unit 3) </td>
      <td><a style={{textDecoration:'none'}} href='https://drive.google.com/file/d/1JaPJGwzOGZ0gYnt1VBXs56uyZJoPygHc/view?usp=drive_link' download> Open <i class="fa fa-download" style={{fontSize:'17px'}}></i></a></td>
    </tr>
    <tr>
      <th scope="row">10</th>
      <td colspan="2">BDA (Unit 1) </td>
      <td><a style={{textDecoration:'none'}} href='https://drive.google.com/file/d/18WmG9FMk2DgAtfDbAFS8fQQ7P1OH2Mcf/view?usp=drive_link' download> Open <i class="fa fa-download" style={{fontSize:'17px'}}></i></a></td>
    </tr>
    <tr>
      <th scope="row">11</th>
      <td colspan="2">BDA (Unit 2) </td>
      <td><a style={{textDecoration:'none'}} href='https://drive.google.com/file/d/1qXnn3HLyvdncVVrtfRUzPDcGDuQQzsEe/view?usp=drive_link' download> Open <i class="fa fa-download" style={{fontSize:'17px'}}></i></a></td>
    </tr>
    <tr>
      <th scope="row">12</th>
      <td colspan="2">DM Lec1 </td>
      <td><a style={{textDecoration:'none'}} href='https://docs.google.com/presentation/d/15OOvOr-4iRQzeOZc9EoPmKQGZ3Ns1ZzX/edit?usp=drive_link&ouid=100677563929140927255&rtpof=true&sd=true' download> Open <i class="fa fa-download" style={{fontSize:'17px'}}></i></a></td>
    </tr>
    <tr>
      <th scope="row">13</th>
      <td colspan="2">DM Lec 3 </td>
      <td><a style={{textDecoration:'none'}} href='https://docs.google.com/presentation/d/1ehnSwdHTMLOZvkqQEzV3iCI7rC8PBZgO/edit?usp=drive_link&ouid=100677563929140927255&rtpof=true&sd=true' download> Open <i class="fa fa-download" style={{fontSize:'17px'}}></i></a></td>
    </tr>
    <tr>
      <th scope="row">14</th>
      <td colspan="2">DM Lec 6 </td>
      <td><a style={{textDecoration:'none'}} href='https://docs.google.com/presentation/d/1YZash5VQlyeC_WLyws8VmupqpPYeJz_V/edit?usp=drive_link&ouid=100677563929140927255&rtpof=true&sd=true' download> Open <i class="fa fa-download" style={{fontSize:'17px'}}></i></a></td>
    </tr>
    <tr>
      <th scope="row">15</th>
      <td colspan="2">BDA Imp Questions (Unit 1) </td>
      <td><a style={{textDecoration:'none'}} href='https://drive.google.com/file/d/1i5erxcErqKkgS5ti0RYD20fQyURXkFC8/view?usp=drive_link' download> Open <i class="fa fa-download" style={{fontSize:'17px'}}></i></a></td>
    </tr>
    <tr>
      <th scope="row">16</th>
      <td colspan="2">BDA Imp Questions (Unit 3,) </td>
      <td><a style={{textDecoration:'none'}} href='https://drive.google.com/file/d/1RikHCxPh62-qCIu7O6qLk7yS8BEydI-x/view?usp=drive_link' download> Open <i class="fa fa-download" style={{fontSize:'17px'}}></i></a></td>
    </tr>
    <tr>
      <th scope="row">17</th>
      <td colspan="2">BDA Imp Questions (Unit 2) </td>
      <td><a style={{textDecoration:'none'}} href='https://drive.google.com/file/d/1kibyJUzOmYqKOb4dvhaCZM9iurN2FVex/view?usp=drive_link' download> Open <i class="fa fa-download" style={{fontSize:'17px'}}></i></a></td>
    </tr>
  </tbody>
</table>
</Container>
        </div>
    );
}

export default Year4;
